import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListItem,{staticClass:"py-1"},[_c(VListItemContent,[_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.$t('labels.refusal')))]),_c(VListItemTitle,[_vm._v(_vm._s(_vm.refusal))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }